import { render } from "./NewReferralModal.vue?vue&type=template&id=0e6dbfee"
import script from "./NewReferralModal.vue?vue&type=script&lang=js"
export * from "./NewReferralModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__